import { render } from "./SidebarProfessor.vue?vue&type=template&id=81510b78&scoped=true"
import script from "./SidebarProfessor.vue?vue&type=script&lang=js"
export * from "./SidebarProfessor.vue?vue&type=script&lang=js"

import "./SidebarProfessor.vue?vue&type=style&index=0&id=81510b78&lang=scss"
import "./SidebarProfessor.vue?vue&type=style&index=1&id=81510b78&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81510b78"]])

export default __exports__